import { ReactElement, useRef, useMemo } from 'react'
import {
  WebsiteLayout,
  PressGuidelinesCard,
  GeneralInformationCard,
  FromOurBlogSection,
  useUpdateHeader,
  HEADER_THEMES,
  useCleanHeader,
  WebsiteSeo,
} from '@platform/website-components'
import { Link } from '@platform/ui-kit'
import { Locale, useGetWebsitePressPageQuery } from '@platform/data-access'
import { websiteFormatArticleList } from '@platform/utils'

import styles from './index.module.scss'

const SEO = {
  title: 'Press // Olby',
}

const Press = () => {
  const sectionRef = useRef<HTMLDivElement | null>(null)
  useUpdateHeader(sectionRef, HEADER_THEMES.NEUTRAL_BACKGROUND)
  useCleanHeader()

  const { data } = useGetWebsitePressPageQuery({ input: { locale: Locale.En } })

  const posts = useMemo(() => {
    if (!data?.getWebsitePressPage?.data) {
      return []
    }
    const list = data.getWebsitePressPage.data.posts?.map(({ post }) => post)
    const formattedArticles = websiteFormatArticleList(list || [])
    return formattedArticles
  }, [data])

  return (
    <div>
      <WebsiteSeo seo={SEO} />
      <div className={styles['content-wrapper']} ref={sectionRef}>
        <h1 className={styles['title']}>Press</h1>
        <p className={styles['description']}>
          Don&apos;t see what you&apos;re looking for?{' '}
          <Link href="/contact-us" prefetch={false}>
            Contact us
          </Link>
        </p>
        <div className={styles['content']}>
          <PressGuidelinesCard />
          <GeneralInformationCard />
        </div>
      </div>
      <FromOurBlogSection posts={posts} />
    </div>
  )
}

export default Press

Press.getLayout = (page: ReactElement) => {
  return (
    <WebsiteLayout shouldChangeBgColor headerInitialTheme={HEADER_THEMES.NEUTRAL_BACKGROUND}>
      {page}
    </WebsiteLayout>
  )
}
